// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__y-JX2","choiceBoxes":"toolbarselects_choiceBoxes__16Qg9","simpleField":"toolbarselects_simpleField__2u9vZ"};